module.exports = __webpack_public_path__ + "static/img/1054_small.b78d259.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1054_small.png
// module id = berE
// module chunks = 1